const routes = [
// 首页
{
  path: "/home",
  name: 'home',
  component: () => import("../views/home/index.vue")
},
// 商品管理
{
  path: "/goods-search",
  name: "goods-search",
  component: () => import("../views/goods/goods-search.vue")
}, {
  path: "/goods-cart",
  name: "goods-cart",
  component: () => import("../views/goods/goods-cart.vue")
}, {
  path: "/goods-upOrder",
  name: "goods-upOrder",
  component: () => import("../views/goods/goods-upOrder.vue")
}, {
  path: "/goods-odManagement",
  name: "goods-odManagement",
  component: () => import("../views/goods/goods-odManagement.vue")
}, {
  path: "/goods-odManagement-detail",
  name: "goods-odManagement-detail",
  component: () => import("../views/goods/goods-odManagement-detail.vue")
}, {
  path: "/goods-IntelligentOrdering",
  name: "goods-IntelligentOrdering",
  component: () => import("../views/goods/goods-IntelligentOrdering.vue")
}, {
  path: "/goods-IntelligentOrdering-detail",
  name: "goods-IntelligentOrdering-detail",
  component: () => import("../views/goods/goods-IntelligentOrdering-detail.vue")
},
// 订单管理
{
  path: "/order-search",
  name: "order-search",
  component: () => import("../views/order/order-search.vue")
}, {
  path: "/order-search-detail",
  name: "order-search-detail",
  component: () => import("../views/order/order-search-detail.vue")
}, {
  path: "/order-wholesale",
  name: "order-wholesale",
  component: () => import("../views/order/order-wholesale.vue")
}, {
  path: "/order-wholesale-detail",
  name: "order-wholesale-detail",
  component: () => import("../views/order/order-wholesale-detail.vue")
}, {
  path: "/order-subcontract",
  name: "order-subcontract",
  component: () => import("../views/order/order-subcontract.vue")
}, {
  path: "/order-subcontract-detail",
  name: "order-subcontract-detail",
  component: () => import("../views/order/order-subcontract-detail.vue")
}, {
  path: "/order-send",
  name: "order-send",
  component: () => import("../views/order/order-send.vue")
}, {
  path: "/order-send-detail",
  name: "order-send-detail",
  component: () => import("../views/order/order-send-detail.vue")
}, {
  path: "/order-contractApply",
  name: "order-contractApply",
  component: () => import("../views/order/order-contractApply.vue")
}, {
  path: "/order-search-returns",
  name: "order-search-returns",
  component: () => import("../views/order/order-search-returns.vue")
}, {
  path: "/order-afterService",
  name: "order-afterService",
  component: () => import("../views/order/order-afterService.vue")
}, {
  path: "/order-invoice",
  name: "order-invoice",
  component: () => import("../views/order/order-invoice.vue")
},
// 企业管理
{
  path: "/enterprise-myCredit",
  name: "enterprise-myCredit",
  component: () => import("../views/creditExtension/myCredit.vue")
}, {
  path: "/enterprise-addressManagement",
  name: "enterprise-addressManagement",
  component: () => import("../views/creditExtension/enterprise-addressManagement.vue")
}, {
  path: "/enterprise-memberManagement",
  name: "enterprise-memberManagement",
  component: () => import("../views/creditExtension/enterprise-memberManagement.vue")
}, {
  path: "/enterprise-maintain",
  name: "enterprise-maintain",
  component: () => import("../views/creditExtension/enterprise-maintain.vue")
}, {
  path: "/enterprise-deliveryBeforePayment",
  name: "enterprise-deliveryBeforePayment",
  component: () => import("../views/creditExtension/enterprise-deliveryBeforePayment.vue")
},
// {
//   path: "/enterprise-bindingBusiness",
//   name: "enterprise-bindingBusiness",
//   component: () => import("../views/creditExtension/enterprise-bindingBusiness.vue"),
// },
// 业务流程
// {
//   path:"/process-introduce",
//   name: "process-introduce",
//   component: () => import("../views/process/process-introduce.vue"),
// },
// 支付
{
  path: "/pay",
  name: "pay",
  component: () => import("../views/pay/index.vue")
},
// 微信支付
{
  path: "/pay-weixin",
  name: "pay-weixin",
  component: () => import("../views/pay/pay-weixin.vue")
},
// 先货后款支付
{
  path: "/deliveryBeforePaymentPay",
  name: "deliveryBeforePaymentPay",
  component: () => import("../views/deliveryBeforePaymentPay/index.vue")
},
// 先货后款微信支付
{
  path: "/dbpPay-weixin",
  name: "dbpPay-weixin",
  component: () => import("../views/deliveryBeforePaymentPay/dbpPay-weixin.vue")
},
// 登录
{
  path: "/login",
  name: "login",
  component: () => import("../views/login/index.vue")
},
// 注册
{
  path: "/register",
  name: "register",
  component: () => import("../views/register/index.vue")
},
// 详情页
{
  path: "/detail",
  name: "detail",
  component: () => import("../views/detail/index.vue")
},
// 帮助手册
{
  path: "/buyerHelpManual",
  name: "buyerHelpManual",
  component: () => import("../views/buyerHelpManual/index.vue")
},
// 客服
{
  path: "/chat",
  name: "chat",
  component: () => import("../views/chat/index.vue")
},
// 政策咨询
{
  path: "/information",
  name: "information",
  component: () => import("../views/information/index.vue")
},
// 公告消息
{
  path: "/newsDetDetail",
  name: "newsDetDetail",
  component: () => import("../views/newsDetDetail/index.vue")
}, {
  path: "/",
  redirect: "/home"
}, {
  path: '*',
  name: '/404',
  component: () => import("../views/common/404.vue")
}];
export default routes;